import { Component } from "react";
import { connect } from "react-redux";
import { GET_LISTDATA } from "../../actions";
import Select from "react-select";
import { adminlimit } from "../Settings/Config";
import { showContaimerLoader, showStatus, encodeValue, removeItem, showPageCount, normalizeValue, renderSortIcon, hasPermission, addModule } from "../Settings/Settings";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import Pagenation from "../Layout/Pagenation";
const module = "company";
const modulePath = "/owner";
const moduleName = "Client";
const moduleID = 2;
class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageLimit: { label: adminlimit, value: adminlimit },
      loading: true,
      totalRecords: 0,
      totalPage: 0,
      currentPage: 1,
      listdata: [],
      name: "",
      status: "",
      sortKey: "",
      sortType: "",
    };
    this.handleChangeText = this.handleChangeText.bind(this);
  }

  componentDidMount() {
    if (!hasPermission(moduleID, "view")) {
      this.props.history.push("/search");
    } else {
      this.loadList(1);
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.listdata !== this.state.listdata) {
      this.setState({
        listdata: nextProps.listdata,
        loading: false,
        totalRecords: nextProps.totalRecords,
        totalPage: nextProps.totalPages,
      });
    }
  }
  searchList(e) {
    e.preventDefault();
    this.setState({ loading: true, currentPage: 1 }, () => {
      this.loadList(1);
    });
  }
  resetSearch(e) {
    e.preventDefault();
    this.setState(
      {
        loading: true,
        name: "",
        status: "",
        currentPage: 1,
        sortKey: "",
        sortType: "",
      },
      () => {
        this.loadList(1);
      },
    );
  }

  loadList(offset) {
    this.setState({ loading: true });
    let addParams = "";
    if (this.state.name !== "") {
      addParams += "&name=" + this.state.name;
    }
    if (this.state.status !== null && Object.keys(this.state.status).length > 0) {
      addParams += "&status=" + this.state.status.value;
    }

    const params = {
      params: `limit=${this.state.pageLimit.value}&offset=${offset}&sortKey=${this.state.sortKey}&sortType=${this.state.sortType}${addParams}`,
      url: `${module}`,
    };
    this.props.getListData(params);
  }
  edit(editID, e) {
    e.preventDefault();
    this.props.history.push({
      pathname: `${modulePath}/edit`,
      state: { editID: encodeValue(editID) },
    });
  }
  sateValChange = (field, value) => {
    if (field === "page") {
      if(this.state.currentPage!==value) {
        this.setState(
          {
            loading: true,
            currentPage: value,
          },
          () => {
            this.loadList(value);
          },
        );
      }
    } else if (field === "pageLimit") {
      this.setState({ pageLimit: value, currentPage: 1 }, () => {
        this.loadList(1);
      });
    }
  };
  handleChangeText(event) {
    const name = event.target.name;
    const value = event.target.value;
    this.setState({ [name]: value });
  }
  handleSelectChange(name, value) {
    this.setState({ [name]: value });
  }
  removeItem(deleteID, e) {
    e.preventDefault();
    removeItem(deleteID, module, this.sateValChange, this.state.currentPage);
  }

  handleSort = (field) => {
    let type = "ASC";

    if (this.state.sortKey === field && this.state.sortType === "ASC") {
      type = "DESC";
    }

    this.setState(
      {
        sortKey: field,
        sortType: type,
      },
      () => {
        this.setState({ currentPage: 1 }, () => {
          this.loadList(1);
        });
      },
    );
  };

  render() {
    return (
      <div>
        <div className="page">
          <div className="page-main">
            <Header currentPage={module} {...this.props} />

            <div className="main-content app-content">
              <div className="side-app">
                <div className="main-container container-fluid mx-3">
                  {addModule(moduleID, moduleName, modulePath)}
                  <div className="row">
                    <div className="col-md-12 col-xl-12">
                      <div className="card">
                        <div className="card-body">
                          <div className="form-row">
                            <div className="col-md-3">
                              <input type="text" className="form-control" placeholder={"Search keyword"} name="name" onChange={this.handleChangeText} value={this.state.name} />
                            </div>

                            <div className="col-md-2">
                              <Select
                                value={this.state.status}
                                onChange={this.handleSelectChange.bind(this, "status")}
                                placeholder="Select Status"
                                isClearable={true}
                                options={[
                                  { value: "A", label: "Active" },
                                  { value: "I", label: "In Active" },
                                ]}
                              />
                            </div>
                            <div className="col-md-3">
                              <a href="/" className="btn btn-primary" onClick={this.searchList.bind(this)}>
                                Search
                              </a>
                              <a href="/" className="btn btn-secondary offset-1" onClick={this.resetSearch.bind(this)}>
                                Reload
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-xl-12">
                      <div className="card">
                        <div>
                          <div className="card-header">
                            {parseInt(this.state.totalPage) > 0 &&
                              showPageCount(moduleName, this.state.currentPage, this.state.totalPage, this.state.totalRecords, this.sateValChange, this.state.pageLimit)}
                          </div>
                          <div className="card-body">
                            <div className="table-responsive">
                              <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                                <thead className="table-primary">
                                  <tr>
                                    {(hasPermission(moduleID, "edit") || hasPermission(moduleID, "delete")) && <th className="text-center">Actions </th>}
                                    <th>S.No.</th>
                                    <th onClick={() => this.handleSort("company_name")}>Client Name {renderSortIcon("company_name", this.state.sortKey, this.state.sortType)}</th>
                                    <th>Contact Person</th>
                                    <th>Address</th>
                                    <th>Vessel Name List</th>
                                    <th>GST Number</th>
                                    <th>Phone</th>
                                    <th>Email</th>
                                    <th>Management Type</th>
                                    <th>RPSL</th>
                                    <th>Status</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state.loading ? (
                                    <tr>
                                      <td colSpan={12}>{showContaimerLoader()}</td>
                                    </tr>
                                  ) : this.state.listdata.length > 0 ? (
                                    this.state.listdata.map((item, index) => {
                                      const vesselName = item.vesselName !== "" && item.vesselName !== null ? item.vesselName.split(",") : [];
                                      return (
                                        <tr key={index} className={`${item.companyStatus === "I" ? "bg-danger text-white" : ""}`}>
                                          {(hasPermission(moduleID, "edit") || hasPermission(moduleID, "delete")) && (
                                            <td className="text-center text-nowrap" valign="top">
                                              {hasPermission(moduleID, "edit") && (
                                                <a href="/" onClick={this.edit.bind(this, item.company_id)} className="me-2">
                                                  <i className="fa fa-pencil-square-o"></i>
                                                </a>
                                              )}
                                              {hasPermission(moduleID, "delete") && (
                                                <a href="/" className="delete_record" onClick={this.removeItem.bind(this, encodeValue(item.company_id))}>
                                                  <i className="fa fa-trash"></i>
                                                </a>
                                              )}
                                            </td>
                                          )}
                                          <td>{(parseInt(this.state.currentPage) - 1) * parseInt(this.state.pageLimit.value) + (parseInt(index) + 1)}</td>
                                          <td>{normalizeValue(item.company_name)}</td>
                                          <td>{normalizeValue(item.contact_person)}</td>
                                          <td className="allowweap">
                                            <div style={{ width: "200px" }}>{normalizeValue(item.address)}</div>
                                          </td>
                                          <td className="allowweap">
                                            <div style={{ width: "200px" }}>
                                              {vesselName.length > 0 && (
                                                <ul>
                                                  {vesselName.map((vItem, index) => (
                                                    <li key={index}>{vItem}</li>
                                                  ))}
                                                </ul>
                                              )}
                                            </div>
                                          </td>
                                          <td>{normalizeValue(item.GSTNumber)}</td>
                                          <td>{normalizeValue(item.phone)}</td>
                                          <td>{normalizeValue(item.email)}</td>
                                          <td>{normalizeValue(item.management)}</td>
                                          <td>{normalizeValue(item.rpsl ?? "No")}</td>
                                          <td>{showStatus(item.companyStatus)}</td>
                                        </tr>
                                      );
                                    })
                                  ) : (
                                    <tr>
                                      <td className="text-center" colSpan={11}>
                                        No {moduleName} Found
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                            {parseInt(this.state.totalPage) > 1 && (
                              <Pagenation
                                params={{
                                  totalRecords: this.state.totalRecords,
                                  totalPage: this.state.totalPage,
                                  currentPage: this.state.currentPage,
                                }}
                                sateValChange={this.sateValChange}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  let listdata = [];
  let totalPages = 0;
  let totalRecords = 0;
  if (Object.keys(state.listdata).length > 0) {
    if (state.listdata[0].status === "ok") {
      listdata = state.listdata[0].result;
      totalPages = state.listdata[0].totalPages;
      totalRecords = state.listdata[0].totalRecords;
    }
  }
  return {
    listdata: listdata,
    totalPages: totalPages,
    totalRecords: totalRecords,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getListData: (datas) => {
      dispatch({ type: GET_LISTDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(List);
